module.exports = __webpack_public_path__ + "img/Qi_Logo1.77eeaf43.svg";